import { render, staticRenderFns } from "./swift.vue?vue&type=template&id=36c12940&scoped=true&"
import script from "./swift.vue?vue&type=script&lang=js&"
export * from "./swift.vue?vue&type=script&lang=js&"
import style0 from "./swift.vue?vue&type=style&index=0&id=36c12940&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c12940",
  null
  
)

export default component.exports